// extracted by mini-css-extract-plugin
module.exports = {"title":"c6e8ba5398--title--2CW78"};